import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Device } from "../../Device";

const ConnectedFormatter = (props: { device: Device }) => {
  const { t } = useTranslation();

  const value: boolean | null = props.device.connected;

  const label = t(
    `tables.devices.enums.connected.${
      value === null ? "unknown" : value.toString()
    }`
  );

  return (
    <Chip
      variant="filled"
      size="small"
      label={label}
      color={value === null ? "default" : value ? "success" : "error"}
    />
  );
};

export default ConnectedFormatter;
